import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { assert } from '@sama/js-core';
import { find, map } from '@sama/micro-dash';
import { Submission } from '../../../../team-apis/otterdam/submission';

import { TaskWorkspaceStore } from '../../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-submitter-info',
  templateUrl: './submitter-info.component.html',
  styleUrls: ['./submitter-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SubmitterInfoComponent implements OnInit {
  @Input() submissions: Submission[] = [];

  submissionItems: Array<Submission & { stepName: string }> = [];

  constructor(private store: TaskWorkspaceStore) {}

  ngOnInit() {
    this.submissionItems = map(this.submissions, (submission) => {
      const step = find(
        this.store.state().project.steps,
        (s) => s.id === submission.step_id,
      );
      assert(step, 'All submissions must be associated to a step.');
      return {
        ...submission,
        stepName: `${step.ordinal_letter}${submission.round}`,
      };
    });
  }
}
